/** Сводная статистика кассиров — служба Cashiers (RP-SEP1); журнал собственной кассы остаётся в Receipts (`own-journal`). */
const ROOT = '/api/cashiers/v1'
const REPORTS = `${ROOT}/analytics/reports`
export const CASHIER_ANALYTICS_URLS = {
  reports: REPORTS,
  reportReceipts: (id: string) => `${REPORTS}/${encodeURIComponent(id)}/receipts`,
  /** Привязка «аккаунт ↔ кассир» текущего аккаунта (RP-STAT-UNIFY): рекомендованный кассир и право выбирать любого. */
  myBinding: `${ROOT}/account-bindings/me`,
  groupSummary: (id: string) => `${ROOT}/groups/${encodeURIComponent(id)}/summary`,
  groupReceipts: (id: string) => `${ROOT}/groups/${encodeURIComponent(id)}/receipts`,
} as const
